<template>
  <div class="cases">
    <Header />
    <div class="banner"></div>
    <router-view></router-view>
    <Footer />
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style lang="less" scoped>
.cases {
  background: #f5f5f5;
}
.banner {
  background: url("../../assets/image/cases-banner.png") no-repeat;
  background-position: center;
  background-size: cover;
  height: 500px;
  position: relative;
  top: 140px;
  margin-bottom: 140px;
  width: 100%;
}
@media (max-width: 1024px) and (min-width: 768px) {
  .banner {
    top: 75px;
    margin-bottom: 75px;
    height: 270px;
    background-size: contain;
  }
}

@media (max-width: 768px) and (min-width: 320px) {
  .banner {
    height: 205px;
  }
}
@media (max-width: 767px) and (min-width: 320px) {
  .banner {
    background-image: url("../../assets/image/case-app.jpeg");
    background-position: center;
    top: 50px;
    margin-bottom: 50px;
    height: 230px;
  }
}
</style>
